import React from 'react';
import { CuttingUploadCard, FormulaCard } from './CuttingUploadCard';
import { CuttingResultsCard } from './CuttingResults';
import { CuttingHistoryCard } from './CuttingHistory';

export function CuttingTab(props) {
  function handleFileChange(e) {
    props.setCuttingFile(e.target.files[0]);
  }
  
  function clearFile() {
    props.setCuttingFile(null);
  }
  
  function updateBlade(e) {
    props.setCuttingSettings({...props.cuttingSettings, blade_kerf_mm: parseFloat(e.target.value) || 3});
  }
  
  function updateTrim(e) {
    props.setCuttingSettings({...props.cuttingSettings, end_trim_mm: parseFloat(e.target.value) || 5});
  }
  
  function updateJob(v) {
    props.setCuttingSettings({...props.cuttingSettings, job_id: v === 'none' ? '' : v});
  }

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <CuttingUploadCard 
          cuttingFile={props.cuttingFile}
          handleFileChange={handleFileChange}
          clearFile={clearFile}
          cuttingSettings={props.cuttingSettings}
          updateBlade={updateBlade}
          updateTrim={updateTrim}
          updateJob={updateJob}
          handleCuttingUpload={props.handleCuttingUpload}
          cuttingProcessing={props.cuttingProcessing}
          jobs={props.jobs}
        />
        <FormulaCard />
      </div>
      {props.cuttingResults && <CuttingResultsCard results={props.cuttingResults} />}
      <CuttingHistoryCard history={props.cuttingHistory} />
    </div>
  );
}
